<template>
<v-layout v-resize="onResize" column>
	<!-- <v-layout :class="windowSize.x < 1024 ? 'column' : 'row'" xs12>
		<v-flex xs6>
			<section-pillars
			:window-size="windowSize"
			/>
		</v-flex>
		<v-flex xs6>
			<slider-pillars />
		</v-flex>
	</v-layout> -->
	<div class="content-pillars">
		<div class="content-section">
			<section-pillars :window-size="windowSize"/>
		</div>
		<div class="slider-pillars">
			<slider-pillars />
		</div>
	</div>
	<p class="background-gray"></p>
</v-layout>
</template>

<script>
import sectionPillars from '@/components/pillars/section-pillars';
import sliderPillars from '@/components/pillars/slider-pillars';

function onResize() {
	this.windowSize = { x: window.innerWidth, y: window.innerHeight };
}

function data() {
	return {
		windowSize: {
			x: 0,
			y: 0,
		},
	};
}

export default {
	name: 'page-pillars',
	data,
	components: {
		sectionPillars,
		sliderPillars,
	},
	methods: {
		onResize,
	},
};
</script>

<style lang="scss" scoped>
.background-gray {
	background-color: map-get($colors, background-gray);
	height: 11px;
	width: 100%;
}

.content-pillars {
	display: flex;

	@media (max-width: 1024px) {
		flex-direction: column;
	}
}

.slider-pillars {
	width: 50%;

	@media (max-width: 1024px) {
		width: 100%;
	}
}

.content-section {
	width: 50%;

	@media (max-width: 1024px) {
		width: 100%;
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/page-pillars.vue